// 巡检报告
import { useEffect, useRef } from 'react'
import { message, Modal, Button } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';

//下载文件 默认下载word文件
function DownloadFile(props) {
  // props 参数

  // open 弹窗是否打开 de:false
  // btnLoading 按钮加载状态 de:false
  // title 弹窗标题 de:下载文件
  // content 弹窗内容 de:报告文件已准备，点击按钮下载
  // downloadFileType 下载文件类型 de: 'application/msword'
  // fileName 下载的文件名称 de:文件
  // downloadFileUrl 文件的url地址
  // close 关闭

  const open = props.open || false;
  const btnLoading = props.btnLoading || false;
  const title = props.title || '下载文件';
  const content = props.content || '报告文件已准备，点击按钮下载';
  const downloadFileType = props.downloadFileType || 'application/msword';
  const fileName = props.fileName || '文件';
  const downloadFileUrl = props.downloadFileUrl || null;

  const downloadFile = useRef(null);

  useEffect(() => {
    if (downloadFileUrl) {
      urlToFile(downloadFileUrl);
    }
  }, [downloadFileUrl]);// eslint-disable-line

  useEffect(() => {
    return (() => {
    })
  }, []);// eslint-disable-line

  //地址转文件
  const urlToFile = (url) => {
    return new Promise((resolve, reject) => {
      var blob = null;
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      xhr.setRequestHeader('Accept', downloadFileType);
      xhr.responseType = "blob";
      // 加载时处理
      xhr.onload = () => {
        // 获取返回结果
        blob = xhr.response;
        let file = new File([blob], 'xxx', { type: downloadFileType });
        downloadFile.current = file;
        // 返回结果
        resolve(file);
      };
      xhr.onerror = (e) => {
        message.warning('文件转换失败');
        reject(e)
      };
      // 发送
      xhr.send();
    });
  }

  //保存文件
  async function saveFile() {
    if (!downloadFile.current) {
      message.warning('没有下载的文件');
      return;
    }
    try {
      const opts = {
        types: [
          {
            description: '文件',
            accept: {
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx', '.doc']
            },
          }
        ],
        suggestedName: fileName,
        excludeAcceptAllOption: true
      };
      const handle = await window.showSaveFilePicker(opts); // 打开保存文件对话框
      const writable = await handle.createWritable(); // 创建可写入的文件对象

      // 在这里写入文件内容
      await writable.write(downloadFile.current);
      await writable.close();
      message.success('文件保存成功');
      if (props.close) {
        props.close();
      }
    } catch (error) {
      console.log(error);
      let text = JSON.stringify(error);
      if (text.indexOf('The user aborted a request') === -1) {//无法使用另存为
        message.warning('当前浏览器暂不支持另存为操作，请直接下载 或更换以下浏览器：谷歌、edge、360');
      }
    }
  }

  return (
    <div className="padd_24 flex-col hei100 tablebackcol" style={{ overflowY: 'auto', display: open ? '' : 'none' }}>
      <a id='a_report' href='undefined' download="巡检报告.docx" style={{ display: 'none' }}>
        查看
      </a>
      <Modal title="" width={416} open={open}
        footer={false} closable={false} destroyOnClose={true}
      >

        <div className='marB8 flex_row align_center'>
          <span className='fs22 marR16 col_primary'><ExclamationCircleOutlined /></span>
          <span style={{ fontWeight: 500, fontSize: 16, color: 'rgba(255, 255, 255, 0.85)' }}>
            {title}
          </span>
        </div>
        <div className='fs14 marL38' style={{ fontSize: 14, color: 'rgba(255, 255, 255, 0.85)' }}>
          {content}
        </div>

        <div className='marT24 tr'>
          <Button className='marR8' onClick={() => {
            if (props.close) {
              props.close();
            }
          }}>取消</Button>

          <Button id='xxx' className='marR8' type="primary" loading={btnLoading} onClick={() => {
            let aLink = document.getElementById('a_report');
            if (!downloadFileUrl) {
              message.warning('没有下载的文件地址');
              return;
            }
            aLink.download = '';
            aLink.href = downloadFileUrl;
            aLink.click();
          }}>下载</Button>

          <Button type="primary" loading={btnLoading} onClick={() => {
            saveFile();
          }}>另存为</Button>
        </div>
      </Modal>
    </div>
  )
}
export default DownloadFile
